import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { postCreateInvoiceAttachment } from '../services/postCreateInvoiceAttachment';

export const createInvoiceAttachment = createAsyncThunk(
  'saleInvoices/createInvoiceAttachment',
  async (params, { getState }) => {
    const { invoiceId, attachment } = params;

    if (!invoiceId) {
      throw new Error('No invoice id provided');
    }

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await postCreateInvoiceAttachment(
      selectedProjectId,
      invoiceId,
      attachment
    );

    return response;
  }
);
